<template>
  <div class="tw-grid tw-grid-cols-5 tw-gap-8">
    <div class="tw-col-start-3">
      <SelectWidget :value="breakdown" @input="$emit('update:breakdown', $event)" :options="breakdownOptions"/>
    </div>

    <div>
      <DateWidget :value="from" @input="$emit('update:from', $event)"/>
    </div>

    <div>
      <DateWidget :value="to" @input="$emit('update:to', $event)"/>
    </div>
  </div>
</template>

<script>
import DateWidget from '../../../../../../../vendor/forms/FormGroups/Widgets/Date'
import SelectWidget from '../../../../../../../vendor/forms/FormGroups/Widgets/Select'

export default {
  components: {DateWidget, SelectWidget},

  props: {
    from: {
      required: true
    },

    to: {
      required: true
    },

    breakdown: {
      required: true
    }
  },

  computed: {
    breakdownOptions() {
      return [
        {value: 'months', label: 'Months'},
        {value: 'weeks', label: 'Weeks'},
      ]
    }
  }
}
</script>
